<template>
<ScreenLayout>
    <div slot="left">

    </div>

    <div slot="right">
        
    </div>

</ScreenLayout>
</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'

export default {
    name: 'Template',
    components: {ScreenLayout},
    data() {
        return {

        }
    },
    computed:{

    },
    methods: {

    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Console.vue?5171a65f